import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {Identifier, useNotify} from "react-admin";
import Box from "@mui/material/Box";
import {apiUrl, httpClient} from "../dataProvider";
import {Stack, Typography} from "@mui/material";

interface Props {
    isOpen: boolean;
    setIsOpen: any;
    record: any;
    setRecord: any;
    refresh: any;
    setRefresh: any;
    employeeId: Identifier;
}

export const DocumentDeleteWarningDialog = (props: Props) => {
    const handleClose = () => {
        props.setRecord(null)
        props.setIsOpen(false);
    };

    const notify = useNotify();

    if(props.record === null) return null;

    return <Dialog open={props.isOpen} onClose={handleClose} fullWidth
                   maxWidth="xs">
        <DialogTitle>Dokumentum törlése</DialogTitle>
        <DialogContent>
            <Typography>Biztosan törölni szeretnéd ezt a dokumentumot: <b>{props.record.name}?</b></Typography>
            <Box sx={{height: '25px'}}/>
            <Stack direction={'row'} alignItems={'center'} justifyContent={"space-between"}>
                <Button variant={'contained'}
                        color={"error"}
                        sx={{width: '150px'}}
                        onClick={handleClose}>
                    Mégsem
                </Button>
                <Button variant={'contained'}
                        sx={{width: '150px'}}
                        onClick={async () => {
                            httpClient(`${apiUrl}/employee/${props.employeeId}/attachment/${props.record.id}`, {
                                method: 'DELETE',
                            }).then(r => {
                                if (r.status === 204) {
                                    notify(`Eltávolítva`, {type: 'success'});
                                    props.setRefresh(!props.refresh);
                                    props.setIsOpen(false);
                                } else {
                                    notify(`Hiba történt az eltávolítás során`, {type: 'error'});
                                }
                            })
                        }}>
                    Igen
                </Button>
            </Stack>
        </DialogContent>
    </Dialog>;
}
